import React from 'react'
import ResellMy from './ResellMy'
import '../../css/page/ResellPage.css'


export default class ResellAccountPage extends React.Component {
    componentDidMount () {
        document.title = '分销中心'
    }
    render() {
        return (
            <div className='wk-page resell-center-page'>
                <ResellMy />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/resell/ResellAccountPage.js